import { colors, Icon } from '@tviklax/ui-components';

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'Delivered': return <Icon name="CheckCircle" style={{ color: colors.success }} />;
    case 'In Transit': return <Icon name="Truck" style={{ color: colors.primary }} />;
    case 'Picked Up': return <Icon name="Truck" style={{ color: colors.primary }} />;
    case 'Customs': return <Icon name="ShieldCheck" style={{ color: colors.warning }} />;
    case 'Processing': return <Icon name="Clock" style={{ color: colors.warning }} />;
    case 'Pending': return <Icon name="AlertCircle" style={{ color: colors.warning }} />;
    case 'Booked':
    case 'Order Placed': return <Icon name="Package" style={{ color: colors.gray500 }} />;
    case 'Confirmed': return <Icon name="CheckCircle" style={{ color: colors.primary }} />;
    case 'Rejected':
    case 'Failed':
    case 'Cancelled': return <Icon name="XCircle" style={{ color: colors.error }} />;
    default: return <Icon name="Clock" style={{ color: colors.gray400 }} />;
  }
};
